module.exports = __webpack_public_path__ + "img/clinica-lobos.5c046f8d.png";